
import { defineComponent, inject, ref, onUnmounted } from "vue";
import { Emitter } from "mitt";
import { ITabConfig } from "@/interfaces/iTabConfig";
import VZTabs from "@/components/content/VZTabs.vue";
import { DrawerComponent } from "@/assets/ts/components";
interface ITabsEmit {
  tabs: ITabConfig[];
  title: string;
  icon?: string;
}
type Events = {
  VZTabsUpdate: ITabsEmit;
};
export default defineComponent({
  name: "upgrade-to-pro-p",
  components: {
    VZTabs,
  },
  setup() {
    const tabs = ref<ITabConfig[]>([]);
    const title = ref<string>("");
    const icon = ref<string>("bi bi-box fs-2 text-primary");
    const emitter: Emitter<Events> | undefined = inject("emitter"); // Inject `emitter`

    emitter?.on("VZTabsUpdate", (value) => {
      tabs.value = value.tabs;
      title.value = value.title;
      icon.value = value.icon ?? "bi bi-box fs-2 text-primary";
    });

    onUnmounted(() => {
      emitter?.off("VZTabsUpdate");
    });
    const hideDrawer = () => {
      DrawerComponent?.getInstance("vz_detail_drawer")?.hide();
    };
    return {
      tabs,
      hideDrawer,
      title,
      icon,
    };
  },
});
